import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/home/SectionLabel";
import { FAQS } from "@/data/content";

export function FaqSection() {
    return (
        <section className="max-w-[900px] mx-auto px-6 lg:px-10 py-20">
            <Reveal>
                <SectionLabel className="text-terracotta">FAQ</SectionLabel>
                <h2 className="font-heading text-4xl sm:text-5xl tracking-tight text-ink mt-4">
                    Questions, answered.
                </h2>
            </Reveal>
            <Reveal delay={0.1}>
                <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-linec">
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i}`}
                                className="font-heading text-xl text-ink py-6 hover:no-underline hover:text-sage"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-inksoft text-base leading-relaxed pb-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </section>
    );
}
